/* Spanish catalog mirroring locale-autopilot-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'ap.review.completed': 'Revisado / aprobado',
  'ap.review.reviewApproved': 'Revisión aprobada',
  'ap.review.approvedNotBooked': 'Aprobado · pendiente de contabilizar',
  'ap.review.booked': 'Contabilizado',
  'ap.review.checked': 'Revisado',
  'ap.review.queueError': 'No se pudo actualizar la cola de tareas. Es posible que este resumen esté incompleto. Vuelve a intentarlo antes de procesar las propuestas.',
  'ap.review.retry': 'Reintentar',
  'ap.review.overduePeriods': '{{count}} plazos están vencidos',
  'ap.review.overduePeriod': '1 plazo está vencido',
  'ap.review.overdueDetails': 'Puntos de seguimiento vencidos: {{count}}. Presentación: {{submissions}}. Pago: {{payments}}.',
  'ap.review.deadlinePoints': '{{overdue}} puntos de seguimiento vencidos y {{upcoming}} próximos',
  'ap.review.missingStatements': 'Faltan extractos bancarios',
  'ap.review.missingStatementsPeriod': 'A estas cuentas les falta el extracto bancario de {{period}}.',
  'ap.monthControl.liveTitle': 'Mes en curso',
  'ap.monthControl.liveBlockedReason': 'El mes está en curso. Puedes procesar y aprobar líneas de forma continua, pero la contabilización final estará disponible después del cierre del mes.',
  'ap.cancelEntry': 'Cancelar asiento',
  'ap.saveEntry': 'Guardar asiento',
  'ap.suggestion': 'Sugerencia de SuperPlumma',
  'ap.amountIncVat': 'Importe (IVA incl.)',
  'ap.saveCorrection': 'Guardar corrección',
  'ap.correct': 'Corregir',
  'ap.openInPayroll': 'Abrir en nómina',
  'ap.payrollLines': 'Líneas de salario',
  'ap.hoursCount': 'Número de horas',
  'ap.hourlyRate': 'Tarifa por hora',
  'ap.monthlyGross': 'Salario mensual (bruto)',
  'ap.holidayPayAccrued': 'Paga de vacaciones devengada (12 %)',
  'ap.employerCosts': 'Costes del empleador',
  'ap.employerContribution': 'Cotización del empleador (14,1 %)',
  'ap.mandatoryPension': 'Pensión ocupacional obligatoria (2 %)',
  'ap.approveAndFile': 'Aprobar y presentar',
  'ap.vatReturnTitle': 'Declaración de IVA',
  'ap.post': 'Partida',
  'ap.checkPost': 'Revisa la partida',
  'ap.allPostsChecked': 'Todas las partidas se han revisado.',
  'ap.registerAsset': 'Registrar activo',
  'ap.backToAssets': 'Volver a los activos',
  'ap.confirmAsset': 'Confirmar activo',
  'ap.registeredAutomatically': 'Registrado automáticamente',
  'ap.balanceGroup': 'Grupo de saldo',
  'ap.amountExVat': 'Importe (sin IVA)',
  'ap.registeredFrom': 'Registrado desde',
  'ap.registeredAssets': 'Activos registrados',
  'ap.approveRegistrations': 'Aprobar registros',
  'ap.saveAllAndApprove': 'Guardar todo y aprobar',
  'ap.skip': 'Omitir',
  'ap.skipped': 'Omitido',
  'ap.amountIncVatShort': 'Importe con IVA',
  'ap.openVoucherFull': 'Abrir el justificante a tamaño completo',
  'ap.security': 'Seguridad',
  'ap.dragVoucherHere': 'Arrastra aquí un justificante desde la bandeja de entrada',
  'ap.approve': 'Aprobar',
  'ap.dragVoucherOntoLine': 'Arrastra un justificante a la línea con la que quieras vincularlo.',
  'ap.approveTask': 'Aprobar tarea',
  'ap.sent': 'Enviado',
  'ap.sentCount': '{{count}} enviados',
  'ap.openVatReturn': 'Abrir la declaración de IVA',
  'ap.openTask': 'Abrir tarea',
  'ap.reopenTask': 'Deshacer aprobación',
  'ap.rerun': 'Revisar de nuevo',
  'ap.rerunHelp': 'Vuelve a obtener la cola desde Functions y reconstruye la lista de agentes. No se contabiliza ni se aprueba nada.',
  'ap.rerunDone': 'El contable IA ha vuelto a revisar {{month}}.',
  'ap.rerunFailed': 'No se pudo volver a ejecutar la revisión.',
  'ap.staleApproval': 'Aprobado el {{date}} · la base ha cambiado desde entonces',
  'ap.bankConnection': 'Conexión bancaria',
  'ap.agent.invoice.title': '{{count}} factura(s) no se han enviado',
  'ap.agent.invoice.titleDone': 'Todas las facturas se han enviado',
  'ap.agent.invoice.desc': '{{drafts}} son borradores y {{unsent}} están terminadas pero sin enviar.',
  'ap.agent.invoice.descDone': 'No hay borradores ni facturas sin enviar en {{year}}.',
  'ap.agent.invoice.detail': 'Un borrador no se reconoce como ingreso ni se envía al cliente. El envío y la contabilización se hacen en la lista de facturas.',
  'ap.agent.invoice.action': 'Abrir lista de facturas',
  'ap.agent.invoice.lineDraft': 'Borrador - no reconocido como ingreso',
  'ap.agent.invoice.lineUnsent': 'Terminada, pero sin enviar',
  'ap.agent.invoice.execute': 'Enviar {{count}} facturas',
  'ap.agent.invoice.choose': 'Seleccionar facturas',
  'ap.agent.invoice.selectAll': 'Seleccionar todas las que se pueden enviar',
  'ap.agent.invoice.selectRow': 'Seleccionar factura',
  'ap.agent.invoice.selectedCount': '{{count}} seleccionadas',
  'ap.agent.invoice.sendableCount': '{{count}} se pueden enviar',
  'ap.agent.invoice.finishDraftFirst': 'Los borradores deben completarse antes de poder enviarse',
  'ap.agent.invoice.sendSelectedOne': 'Enviar la factura seleccionada',
  'ap.agent.invoice.sendSelected': 'Enviar {{count}} facturas seleccionadas',
  'ap.agent.invoice.executeDone': 'facturas enviadas',
  'ap.agent.dunning.title': '{{count}} factura(s) vencida(s) esperan un recordatorio',
  'ap.agent.dunning.titleDone': 'No hay facturas vencidas',
  'ap.agent.dunning.desc': '{{amount}} kr están pendientes después de la fecha de vencimiento.',
  'ap.agent.dunning.descDone': 'Todas las facturas enviadas están dentro de su plazo o pagadas.',
  'ap.agent.dunning.detail': 'Los recordatorios, las comisiones por recordatorio y los intereses de demora se envían desde la lista de facturas. Contable IA no envía nada por su cuenta.',
  'ap.agent.dunning.action': 'Abrir lista de facturas',
  'ap.agent.dunning.line': 'Vencida hace {{days}} día(s) - factura {{num}}',
  'ap.agent.dunning.execute': 'Enviar {{count}} recordatorios',
  'ap.agent.dunning.executeTitle': 'Enviar recordatorios de pago',
  'ap.agent.dunning.executeWarn': 'Los recordatorios van directamente a tus clientes y no se pueden retirar. Los clientes que acaban de pagar sin que el pago esté registrado también recibirán uno.',
  'ap.agent.dunning.executeNote': 'Plumme no recuerda la misma factura con más frecuencia que cada siete días, y omite las facturas saldadas o sin correo electrónico del cliente.',
  'ap.agent.dunning.executeDone': 'recordatorios enviados',
  'ap.agent.inbox.title': '{{count}} justificante(s) de la bandeja de entrada sin contabilizar',
  'ap.agent.inbox.titleDone': 'La bandeja de entrada está vacía',
  'ap.agent.inbox.desc': '{{ready}} están listos para contabilizar y {{review}} necesitan revisión.',
  'ap.agent.inbox.descAnalyzing': '{{count}} justificante(s) aún se están leyendo.',
  'ap.agent.inbox.descDone': 'No hay justificantes pendientes de tramitar.',
  'ap.agent.inbox.detail': 'Los justificantes se leen automáticamente al llegar. La contabilización y la selección de cuenta se aprueban en la bandeja de entrada.',
  'ap.agent.inbox.action': 'Abrir bandeja de entrada',
  'ap.agent.inbox.execute': 'Contabilizar {{count}} justificantes listos',
  'ap.agent.inbox.executeDone': 'justificantes contabilizados',
  'ap.agent.inbox.voucher': 'Justificante',
  'ap.agent.inbox.lineReady': 'Leído y listo para contabilizar',
  'ap.agent.inbox.lineReview': 'Requiere revisión antes de contabilizar',
  'ap.agent.reconcile.title': '{{count}} mes(es) sin conciliar',
  'ap.agent.reconcile.titleDone': 'Todos los meses cerrados están conciliados',
  'ap.agent.reconcile.descEarly': 'Aún no se ha cerrado ningún mes en {{year}}.',
  'ap.agent.reconcile.desc': '{{closed}} de {{total}} meses cerrados están conciliados y contabilizados.',
  'ap.agent.reconcile.descDone': 'La cuenta bancaria de la empresa está conciliada hasta el mes pasado.',
  'ap.agent.reconcile.detail': 'Un mes se considera conciliado cuando el extracto de la empresa está contabilizado y archivado en Banco. La conciliación debe hacerse en orden cronológico.',
  'ap.agent.reconcile.action': 'Abrir banco',
  'ap.agent.reconcile.titleBlockedOrder': 'Primero hay que conciliar {{month}}',
  'ap.agent.reconcile.descBlockedOrder': 'La conciliación se hace en orden cronológico. El saldo de apertura procede del mes anterior, así que una discrepancia allí pasaría inadvertida aquí.',
  'ap.agent.reconcile.detailBlockedOrder': 'Ve a Banco y termina el periodo más antiguo sin conciliar. Entonces este mes se abrirá solo.',
  'ap.agent.reconcile.reasonBlockedOrder': 'Esperando a {{month}}',
  'ap.agent.reconcile.line': 'Sin extracto de la empresa conciliado',
  'ap.agent.quality.title': '{{count}} hallazgo(s) en el control de calidad',
  'ap.agent.quality.titleDone': 'Sin hallazgos en el control de calidad',
  'ap.agent.quality.desc': 'A {{missing}} compra(s) les falta el justificante y {{duplicates}} podrían estar contabilizadas dos veces.',
  'ap.agent.quality.descDone': 'Todas las compras de {{year}} tienen justificante y no se han encontrado posibles duplicados.',
  'ap.agent.quality.detailVat': 'Las compras sin justificante suponen {{vat}} kr en deducciones de IVA que podrían rechazarse en una inspección.',
  'ap.agent.quality.detail': 'Los posibles duplicados son compras con el mismo proveedor, importe y fecha. Deben evaluarse manualmente antes de anular nada.',
  'ap.agent.quality.action': 'Abrir movimientos',
  'ap.agent.quality.purchase': 'Compra',
  'ap.agent.quality.lineDuplicate': '{{count}} registros con el mismo proveedor, importe y fecha',
  'ap.agent.quality.lineMissing': 'Falta el justificante · abre la compra para subir o vincular la documentación',
  'ap.agent.deadline.titleOverdue': '{{count}} plazo(s) han vencido',
  'ap.agent.deadline.title': '{{count}} plazo(s) se acercan',
  'ap.agent.deadline.titleDone': 'No hay plazos en los próximos 30 días',
  'ap.agent.deadline.desc': 'El plazo más próximo es {{name}} el {{date}}.',
  'ap.agent.deadline.descOverdue': '{{count}} presentación(es) vencida(s) siguen abiertas.',
  'ap.agent.deadline.descDone': 'Todas las presentaciones con vencimiento en los próximos 30 días se han enviado.',
  'ap.agent.deadline.lineNotFiled': 'Vencida · no presentada',
  'ap.agent.deadline.lineNotPaid': 'Vencida · no marcada como pagada',
  'ap.agent.deadline.detail': 'Los plazos siguen el periodo de IVA de la empresa y la forma societaria. La presentación se hace en Presentaciones.',
  'ap.agent.deadline.action': 'Abrir presentaciones',
  'ap.agent.deadline.lineOverdue': 'Vencida hace {{days}} día(s)',
  'ap.agent.deadline.line': 'Quedan {{days}} día(s)',
  'ap.agent.annualDeadline.subjectMany': '{{count}} presentaciones',
  'ap.agent.annualDeadline.titleDone': 'Los plazos de {{month}} están resueltos',
  'ap.agent.annualDeadline.titleOverdue': '{{subject}} no se ha presentado — el plazo ha pasado',
  'ap.agent.annualDeadline.title': '{{subject}} vence en {{month}}',
  'ap.agent.annualDeadline.desc': '{{name}} de {{year}} vence el {{date}}.',
  'ap.agent.annualDeadline.descDone': 'Todas las presentaciones con vencimiento en {{month}} están marcadas como enviadas.',
  'ap.agent.annualDeadline.detail': 'El plazo cae en el año posterior al ejercicio de ingresos, por lo que se refiere a las cuentas de {{year}}, no de {{calendarYear}}. Esta fila no bloquea la aprobación del mes.',
  'ap.agent.annualDeadline.action': 'Abrir',
  'ap.agent.annualDeadline.lineFiled': 'Marcada como enviada',
  'ap.agent.annualDeadline.execute': 'Marcar como presentada fuera de Plumme',
  'ap.agent.annualDeadline.executeTitle': 'Marcar como presentada la declaración del registro de accionistas',
  'ap.agent.annualDeadline.executeWarn': 'Plumme no envía nada. Esto solo registra que la declaración se presentó en otro lugar, para que el plazo deje de avisar.',
  'ap.agent.annualDeadline.executeNote': 'La declaración del registro de accionistas (RF-1086) se presenta desde un sistema de usuario final o Altinn. Las comunidades de vivienda están exentas, y las empresas cuya presentación realiza Euronext VPS en su nombre no deben presentarla ellas mismas.',
  'ap.agent.annualDeadline.executeDone': 'marcadas',
  'ap.agent.annualDeadline.statusDetail': '{{subject}} debe tramitarse en el flujo anual.',
  'ap.agent.mileage.title': '{{count}} trayecto(s) de kilometraje sin documentación',
  'ap.agent.mileage.titleOk': '{{count}} trayecto(s) de kilometraje documentado(s)',
  'ap.agent.mileage.titleEmpty': 'Sin desplazamientos registrados en {{year}}',
  'ap.agent.mileage.desc': 'El registro de kilometraje da {{amount}} kr en deducciones en {{year}}.',
  'ap.agent.mileage.descEmpty': 'Los desplazamientos profesionales son deducibles, pero solo si cada trayecto registra fecha, ruta, finalidad y kilómetros.',
  'ap.agent.mileage.detail': 'Un registro de kilometraje debe mostrar fecha, origen y destino, finalidad y kilómetros de cada trayecto. Los trayectos sin estos datos pueden ser rechazados.',
  'ap.agent.mileage.action': 'Abrir registro de kilometraje',
  'ap.agent.mileage.trip': 'Trayecto sin ruta',
  'ap.agent.mileage.lineNoPurpose': 'Falta la finalidad',
  'ap.agent.mileage.lineNoKm': 'Faltan los kilómetros',
  'ap.agent.mileage.lineNoRoute': 'Falta la ruta',
  'ap.agent.match.title': 'A {{count}} líneas bancarias les falta el justificante',
  'ap.agent.match.titleDone': 'Todas las líneas bancarias tienen justificante',
  'ap.agent.match.desc': '{{count}} justificantes de la bandeja de entrada podrían encajar.',
  'ap.agent.match.descDone': 'Ninguna línea bancaria carece de documentación.',
  'ap.agent.match.detail': 'Un justificante se vincula automáticamente solo cuando encaja con exactamente una línea bancaria y esa línea encaja con exactamente un justificante. En caso de duda, decides tú.',
  'ap.agent.match.action': 'Abrir banco',
  'ap.agent.match.line': 'Falta el justificante',
  'ap.agent.match.execute': 'Vincular justificantes automáticamente',
  'ap.agent.match.executeTitle': 'Vincular justificantes a líneas bancarias',
  'ap.agent.match.executeWarn': 'Los justificantes se adjuntan como documentación a las líneas bancarias. No se contabiliza nada: eso ocurre al conciliar el extracto.',
  'ap.agent.match.executeNote': 'Solo se vinculan las coincidencias inequívocas: el justificante debe encajar con una línea bancaria y la línea con un justificante. Todo lo demás queda para selección manual.',
  'ap.agent.match.executeDone': 'justificantes vinculados',
  'ap.agent.contacts.supplier': 'proveedores',
  'ap.agent.contacts.customer': 'clientes',
  'ap.agent.contacts.title': 'Faltan hasta {{count}} {{noun}} en el registro',
  'ap.agent.contacts.titleDone': 'Todos los {{noun}} están registrados',
  'ap.agent.contacts.desc': 'Nombres que se repiten en la contabilidad sin estar en el registro.',
  'ap.agent.contacts.descDone': 'No hay nombres recurrentes fuera del registro.',
  'ap.agent.contacts.detail': 'Solo se crean el nombre y el número de organización. El correo electrónico, el teléfono y la dirección los completas tú: Plumme no adivina datos de contacto que podrían acabar en una factura.',
  'ap.agent.contacts.openSuppliers': 'Abrir proveedores',
  'ap.agent.contacts.openCustomers': 'Abrir clientes',
  'ap.agent.contacts.line': '{{count}} registros',
  'ap.agent.contacts.execute': 'Crear {{noun}} que faltan',
  'ap.agent.contacts.executeTitle': 'Crear {{noun}} en el registro',
  'ap.agent.contacts.executeWarn': 'Los nombres se crean en el registro. Los registros existentes no se vinculan automáticamente: lo haces al abrir el registro.',
  'ap.agent.contacts.executeNote': 'Plumme solo crea nombres que se repiten al menos dos veces, y omite textos de pago como «Visa» y «Vipps».',
  'ap.agent.contacts.executeDone': 'creados',
  'ap.contact.supplierNumber': 'N.º de proveedor',
  'ap.contact.supplierNumberPh': 'P. ej. 20001',
  'ap.contact.supplierName': 'Nombre del proveedor',
  'ap.contact.customerName': 'Nombre del cliente',
  'ap.contact.namePh': 'Nombre',
  'ap.contact.customerNamePh': 'P. ej. Ejemplo S.L.',
  'ap.contact.org': 'Número de empresa',
  'ap.contact.orgOptional': 'Número de empresa (opcional)',
  'ap.contact.orgPh': '123 456 789',
  'ap.contact.supplierEmailPh': 'invoice@supplier.com',
  'ap.contact.customerEmailPh': 'post@example.com',
  'ap.contact.phonePh': '400 00 000',
  'ap.contact.address': 'Dirección',
  'ap.contact.addressPh': 'Dirección postal',
  'ap.contact.supplierAddressPh': 'Dirección, código postal y localidad',
  'ap.agent.tax.titleBlocked': 'La base imponible no está disponible',
  'ap.agent.tax.descBlocked': 'Las cifras contables de {{year}} no están cargadas.',
  'ap.agent.tax.detail': 'Presentar la declaración de impuestos requiere la integración con Altinn, que aún no está conectada.',
  'ap.agent.tax.blocked': 'Faltan cifras contables',
  'ap.agent.tax.titleDone': 'La declaración de impuestos de {{year}} se ha presentado',
  'ap.agent.tax.title': 'La base imponible de {{year}} está calculada',
  'ap.agent.tax.descEnk': 'Resultado antes de impuestos: {{result}} kr. Un empresario individual tributa por el propietario.',
  'ap.agent.tax.desc': 'Un resultado antes de impuestos de {{result}} kr da {{tax}} kr de impuesto calculado.',
  'ap.agent.tax.action': 'Abrir declaración de impuestos',
  'ap.agent.tax.lineResult': 'Resultado antes de impuestos',
  'ap.agent.tax.lineTax': 'Impuesto calculado',
  'ap.agent.tax.lineLoss': 'Pérdida a compensar',
  'ap.agent.annual.titleBlocked': 'Las cuentas anuales no están disponibles',
  'ap.agent.annual.descBlocked': 'Las cifras contables de {{year}} no están cargadas.',
  'ap.agent.annual.blocked': 'Faltan cifras contables',
  'ap.agent.annual.titleNotRequired': 'Esta empresa no está obligada a presentar cuentas anuales',
  'ap.agent.annual.descNotRequired': 'Un empresario individual presenta una especificación del negocio junto con la declaración de impuestos.',
  'ap.agent.annual.action': 'Abrir cuentas anuales',
  'ap.agent.annual.stepDocument': 'Documento de cuentas anuales',
  'ap.agent.annual.stepBoard': 'Acta del consejo',
  'ap.agent.annual.stepAssembly': 'Acta de la junta general',
  'ap.agent.annual.stepSigned': 'Firma',
  'ap.agent.annual.titleDone': 'Las cuentas anuales de {{year}} se han presentado',
  'ap.agent.annual.title': 'Quedan {{count}} pasos en las cuentas anuales de {{year}}',
  'ap.agent.annual.titleReady': 'Las cuentas anuales de {{year}} están listas para presentar',
  'ap.agent.annual.descClosed': 'El ejercicio fiscal está cerrado.',
  'ap.agent.annual.descOpen': 'El ejercicio fiscal aún no está cerrado.',
  'ap.agent.annual.detail': 'La presentación en el Registro de Cuentas de Empresas requiere la integración con Altinn, que aún no está conectada.',
  'ap.agent.annual.line': 'No completado',
  'ap.execute.title': 'Contabilizar desde Contable IA',
  'ap.execute.running': 'Contabilizando …',
  'ap.execute.warnTitleGeneric': 'Esto no se puede deshacer',
  'ap.execute.warnTitle': 'Esto se contabiliza en tus cuentas',
  'ap.execute.warnBody': 'Los justificantes se contabilizan como compras con la cuenta, el IVA y la forma de pago del análisis del justificante. Eres responsable de que los asientos sean correctos y debes anularlos manualmente si algo está mal.',
  'ap.execute.checked': 'Plumme vuelve a comprobar cada justificante antes de contabilizarlo. Los que no superan la comprobación permanecen en la bandeja de entrada con un motivo.',
  'ap.execute.doneCount': '{{booked}} {{noun}}',
  'ap.execute.done': '{{booked}} justificantes contabilizados',
  'ap.execute.partialCount': '{{done}} {{skipped}} no se completaron y requieren seguimiento.',
  'ap.execute.failed': 'La contabilización no se completó.',
  'ap.lastRun': 'Última revisión {{when}}',
  'ap.lastRunLabel': 'Última revisión',
  'ap.bankDataHelp': 'SuperPlumma usa los extractos bancarios que has importado en Banco. Aún no existe una conexión bancaria directa: sube un extracto en XLSX o CSV para traer las líneas bancarias.',
  'ap.bankData': 'Datos bancarios',
  'ap.bankStatementImported': 'Extracto bancario importado',
  'ap.noBankData': 'Ningún extracto bancario importado',
  'ap.noData': 'Sin datos',
  'ap.importBankStatement': 'Importar extracto bancario',
  'ap.loadingTitle': 'Cargando tus cuentas …',
  'ap.loadingText': 'SuperPlumma está esperando datos de tus cuentas. La lista de tareas aparece en cuanto se cargan las cifras.',
  'ap.disconnectBank': 'Desconectar el banco',
  'ap.connected': 'Conectado',
  'ap.noBankConnected': 'Ningún banco conectado',
  'ap.connectBankHelp': 'Conecta tu banco para que SuperPlumma pueda contabilizar los movimientos bancarios.',
  'ap.bankIdNote': 'La conexión se realiza de forma segura con BankID.',
  'ap.missingBasis': 'Falta la base',
  'ap.rowDescMissing': 'Falta información para que el Contable IA pueda continuar.',
  'ap.rowBlockedReasonDefault': 'Requiere configuración o datos',
  'ap.rowOpen': 'Abrir',
  'ap.working': 'Trabajando …',
  'ap.execute.queued': 'En cola. Se ejecuta aunque cierres la página: se te avisará cuando termine.',
  'ap.execute.queueFailed': 'No se pudo poner la acción en cola.',
  'ap.job.done': '{{booked}} completados.',
  'ap.job.donePartial': '{{booked}} completados · {{skipped}} no se completaron y requieren seguimiento.',
  'ap.job.failed': 'La acción no se completó.',
  'ap.waiting': 'En espera',
  'ap.waitingDetail': 'Aún no se puede procesar',
  'ap.waitingGroup.title': '{{count}} agentes están en espera',
  'ap.waitingGroup.titleOne': '{{agent}} está en espera',
  'ap.waitingGroup.detail': 'Se vuelven relevantes cuando el periodo está listo',
  'ap.oneLineNeedsControl': ' línea necesita revisión',
  'ap.manyLinesNeedControl': ' líneas necesitan revisión',
  'ap.readyHere': '{{count}} listos',
  'ap.openWorklist': 'Abrir lista de trabajo',
  'ap.controlWorklist': 'Revisar lista de trabajo',
  'ap.controlTask': 'Revisar',
  'ap.openPage': 'Abrir página',
  'ap.waitsForPrevious': 'En espera',
  'ap.nextStep': 'Siguiente paso',
  'ap.comeBackLater': 'Vuelve más tarde',
  'ap.solveBlocker': 'Resolver bloqueo',
  'ap.getBankData': 'Obtener datos bancarios',
  'ap.approved': 'Aprobado',
  'ap.whichAgents': '¿Qué agentes quieres activar?',
  'ap.allAgents': 'Todos los agentes',
  'ap.settings.enabledCount': '{{on}} de {{total}} activados',
  'ap.settings.intro': 'SuperPlumma y sus agentes trabajan continuamente en tus cuentas. Elige qué agentes quieres que te ayuden. Puedes cambiar estos ajustes en cualquier momento. El trabajo asignado a agentes desactivados debe gestionarse manualmente.',
  'ap.settings.allHelp': 'Activa o desactiva todos los agentes a la vez.',
  'ap.permission.inbox.label': 'Agente de bandeja de entrada',
  'ap.permission.inbox.desc': 'Lee los recibos y facturas que llegan por correo electrónico o subida y los prepara para la contabilidad.',
  'ap.permission.matching.label': 'Agente de emparejamiento',
  'ap.permission.matching.desc': 'Vincula los justificantes de la bandeja de entrada con las líneas bancarias sin documentación, cuando la coincidencia es inequívoca.',
  'ap.permission.reconciliation.label': 'Agente de conciliación',
  'ap.permission.reconciliation.desc': 'Se asegura de que cada mes cerrado esté realmente conciliado y contabilizado frente a la cuenta bancaria operativa.',
  'ap.permission.control.label': 'Agente de control',
  'ap.permission.control.desc': 'Busca compras sin justificante y posibles asientos duplicados en la contabilidad.',
  'ap.permission.asset.label': 'Agente de activos',
  'ap.permission.asset.desc': 'Sugiere activos fijos para compras de mayor importe. Tú eliges entre gastarlo o amortizarlo por grupo antes de que el mismo justificante se contabilice una sola vez.',
  'ap.permission.vendor.label': 'Agente de proveedores',
  'ap.permission.vendor.desc': 'Crea nuevos proveedores cuando SuperPlumma detecta registros repetidos del mismo proveedor.',
  'ap.permission.customer.label': 'Agente de clientes',
  'ap.permission.customer.desc': 'Crea nuevos clientes cuando SuperPlumma detecta ventas a clientes desconocidos.',
  'ap.permission.invoice.label': 'Agente de facturas',
  'ap.permission.invoice.desc': 'Da seguimiento a los borradores de factura y a las facturas terminadas que no se han enviado al cliente.',
  'ap.permission.dunning.label': 'Agente de reclamaciones',
  'ap.permission.dunning.desc': 'Lleva el control de las facturas vencidas y de cuáles deben reclamarse primero.',
  'ap.permission.deadline.label': 'Agente de plazos',
  'ap.permission.deadline.desc': 'Avisa de los plazos de presentación que se acercan o están vencidos.',
  'ap.permission.mileage.label': 'Agente de kilometraje',
  'ap.permission.mileage.desc': 'Comprueba que el kilometraje profesional incluya la ruta, la finalidad y los kilómetros, para que la deducción esté documentada.',
  'ap.permission.vat.label': 'Agente de IVA',
  'ap.permission.vat.desc': 'Concilia el IVA y prepara la declaración de IVA para su presentación.',
  'ap.permission.tax.label': 'Agente de impuestos',
  'ap.permission.tax.desc': 'Rellena previamente la declaración de impuestos a partir de tu contabilidad.',
  'ap.permission.payroll.label': 'Agente de nóminas',
  'ap.permission.payroll.desc': 'Hace seguimiento de las nóminas pendientes de aprobación. El cálculo y la aprobación se hacen en Nómina.',
  'ap.permission.annual.label': 'Agente de cuentas anuales',
  'ap.permission.annual.desc': 'Prepara las cuentas anuales y las notas al cierre del ejercicio.',
  'ap.beta': 'Beta',
  'ap.heroTitle': 'SuperPlumma hace el trabajo: tú mantienes el control.',
  'ap.heroSub': 'Consulta el trabajo pendiente, revisa las propuestas y aprueba el siguiente paso.',
  'ap.aboutHelp': 'SuperPlumma recopila tareas y prepara propuestas a partir de los datos disponibles. Contabilizar y enviar requiere tu aprobación. El interruptor controla la revisión automática, no la presentación ni el pago.',
  'ap.enabledDescription': 'SuperPlumma revisa tus cuentas cada mañana y reúne todo lo que espera atención. Elige qué áreas deben revisar los agentes. No se contabiliza ni se envía nada sin tu aprobación.',
  'ap.disabledDescription': 'Contable IA está desactivado. Actívalo para que SuperPlumma revise tus cuentas en segundo plano.',
  'ap.monthOpenHelp': 'SuperPlumma prepara sugerencias a lo largo del mes. Algunos pasos esperan a que el periodo esté listo, y todo se actualiza automáticamente cuando llega información nueva.',
  'ap.monthControl.label': 'Revisión del mes',
  'ap.monthControl.permissionDesc': 'Gestiona líneas bancarias, justificantes, contrapartes y posibles activos, y concilia el mes en un solo flujo de trabajo.',
  'ap.monthControl.blockedDesc': 'Faltan datos bancarios. Los justificantes sin línea bancaria aún se pueden procesar.',
  'ap.monthControl.actionableDesc': 'Quedan {{count}} elementos en {{period}}. Las líneas bancarias, los justificantes, las contrapartes, los activos y la conciliación se gestionan juntos.',
  'ap.monthControl.doneDesc': 'La revisión del mes de {{period}} está completa.',
  'ap.monthControl.title': 'Revisión del mes de **{{period}}**',
  'ap.monthControl.detail': 'Procesa las líneas bancarias cronológicamente, vincula justificantes, crea las contrapartes que faltan y revisa los posibles activos en un solo espacio de trabajo. La aprobación es reversible; la contabilización final se sigue haciendo con Conciliar y contabilizar.',
  'ap.monthControl.waitingDetail': 'El periodo está en curso: aún pueden llegar líneas nuevas',
  'ap.monthControl.blockedReason': 'Falta el extracto bancario o la cobertura bancaria',
  'ap.monthControl.action': 'Abrir revisión del mes',
  'ap.monthControl.findingsEmpty': 'Sin posibles desviaciones.',
  'ap.monthControl.finding.deviation': 'Posible desviación',
  'ap.monthControl.finding.missingVoucher': 'Falta el justificante',
  'ap.monthControl.finding.needsReview': 'Requiere revisión antes de la conciliación.',
  'ap.monthControl.count.inboxOne': '{{count}} justificante en la bandeja de entrada',
  'ap.monthControl.count.inboxMany': '{{count}} justificantes en la bandeja de entrada',
  'ap.monthControl.count.bankMissingVoucherOne': '{{count}} línea bancaria sin justificante',
  'ap.monthControl.count.bankMissingVoucherMany': '{{count}} líneas bancarias sin justificante',
  'ap.monthControl.count.bankLineOne': '{{count}} línea bancaria',
  'ap.monthControl.count.bankLineMany': '{{count}} líneas bancarias',
  'ap.monthControl.count.reconciliationOne': '{{count}} conciliación',
  'ap.monthControl.count.reconciliationMany': '{{count}} conciliaciones',
  'ap.monthControl.count.qualityOne': '{{count}} hallazgo del control de calidad',
  'ap.monthControl.count.qualityMany': '{{count}} hallazgos del control de calidad',
  'ap.monthControl.count.assetOne': '{{count}} activo',
  'ap.monthControl.count.assetMany': '{{count}} activos',
  'ap.monthControl.count.supplierOne': '{{count}} proveedor',
  'ap.monthControl.count.supplierMany': '{{count}} proveedores',
  'ap.monthControl.count.customerOne': '{{count}} cliente',
  'ap.monthControl.count.customerMany': '{{count}} clientes',
  'ap.monthControl.count.itemOne': '{{count}} elemento',
  'ap.monthControl.count.itemMany': '{{count}} elementos',
  'ap.monthControl.noDate': 'Sin fecha',
  'ap.monthControl.action.paySupplierInvoice': 'Pagar factura de proveedor',
  'ap.monthControl.action.registerSupplierInvoice': 'Registrar factura de proveedor',
  'ap.monthControl.action.invoicePayment': 'Pago de factura',
  'ap.monthControl.action.registerSale': 'Registrar venta',
  'ap.monthControl.action.registerPurchase': 'Registrar compra',
  'ap.monthControl.block.needsControl': 'El justificante debe revisarse antes de contabilizar.',
  'ap.monthControl.block.missingBookingType': 'Falta el tipo de contabilización.',
  'ap.monthControl.block.missingInvoiceNumber': 'Falta el número de factura.',
  'ap.monthControl.block.lowConfidence': 'Baja confianza en el análisis.',
  'ap.monthControl.block.manualReview': 'El justificante requiere revisión manual.',
  'ap.monthControl.edit.purchase': 'Editar compra',
  'ap.monthControl.edit.sale': 'Editar venta',
  'ap.monthControl.edit.bankFee': 'Editar comisión',
  'ap.monthControl.edit.invoicePayment': 'Editar pago de factura',
});
